export default __webpack_public_path__ + "static/media/Shorya.646484b0.jpeg";